import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询列表
export const queryEmails: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setEmails', { ...state.list, loading: true });
    const res: IPageData = await $http.post('message/email/page', payload);
    commit('setEmails', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setEmails', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查看详情
export const queryEmailDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setEmailDetail', { data: null, loading: true });
    const res = await $http.get(`message/email/get/${payload}`);
    commit('setEmailDetail', { data: res });
  } catch (e) {
    commit('setEmailDetail', { data: null });
  }
};

// 添加
export const addEmail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('message/email/add', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功, 2秒后跳转回列表页面' });
    setTimeout(() => router.push({ name: 'message-sender' }), 2000);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑
export const editEmail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('message/email/edit', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '编辑成功, 2秒后跳转回列表页面' });
    setTimeout(() => router.push({ name: 'message-sender' }), 2000);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 删除
export const deleteEmail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('message/email/delete', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};
